import { notification } from 'antd';
import greenTickIcon from '../../../assets/images/common/tick.svg';
import React from 'react';

export const showNotification = (message) => {
  notification.open({
    className: 'booking-cancellation-notification',
    message: (<span className="title"> <img src={greenTickIcon} alt="arrow" className="icon" /> <span className="text">{ message }</span></span>),
  });
}
